import { motion } from "framer-motion";
import { ArrowUpRight } from "lucide-react";
import Reveal, { EASE } from "./Reveal";

const STREAMS = [
  { index: "01", name: "REAL ESTATE", note: "Values with substance.", target: "#chapter-01" },
  { index: "02", name: "EQUITIES", note: "Participation in progress.", target: "#chapter-02" },
  { index: "03", name: "PRIVATE EQUITY", note: "Entrepreneurial capital.", target: "#chapter-03" },
];

export default function Streams({ scrollTo }) {
  return (
    <section
      id="streams"
      data-testid="streams"
      className="px-6 py-28 sm:px-[8vw] sm:py-36"
    >
      <p className="f-mono mb-4 text-[11px] tracking-[0.35em] text-[#B8860B]">
        OUR FOCUS
      </p>
      <Reveal>
        <h2 className="f-display max-w-2xl text-3xl font-light tracking-tight text-slate-900 sm:text-5xl">
          Three categories. <span className="italic text-[#B8860B]">One focus.</span>
        </h2>
      </Reveal>

      <div className="mt-16 grid gap-5 md:grid-cols-3">
        {STREAMS.map((s, i) => (
          <motion.button
            key={s.name}
            data-testid={`stream-card-${s.index}`}
            onClick={() => scrollTo(s.target)}
            initial={{ opacity: 0, y: 50 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true, margin: "-10% 0px" }}
            transition={{ duration: 0.9, delay: i * 0.15, ease: EASE }}
            whileHover={{ y: -6 }}
            className="group border border-slate-200 bg-white/70 p-8 text-left backdrop-blur-sm transition-shadow duration-500 hover:border-[#D4AF37]/50 hover:shadow-[0_20px_50px_rgba(212,175,55,0.16)] sm:p-10"
          >
            <div className="flex items-start justify-between">
              <span className="f-mono text-xs tracking-[0.3em] text-[#B8860B]">{s.index}</span>
              <ArrowUpRight className="h-5 w-5 text-slate-300 transition-colors duration-500 group-hover:text-[#D4AF37]" />
            </div>
            <p className="f-display mt-14 text-2xl font-light tracking-wide text-slate-900 sm:text-3xl">
              {s.name}
            </p>
            <p className="mt-3 text-sm font-light text-slate-500">{s.note}</p>
            <div className="mt-8 h-px w-full bg-slate-200 transition-colors duration-500 group-hover:bg-[#D4AF37]/60" />
          </motion.button>
        ))}
      </div>
    </section>
  );
}
